<ion-content>
  <div class="warning-feature-banner" *ngIf="isSlackDisconnected">
    <ion-icon name="warning" class="padded-icon"></ion-icon>
    The Unthread app for Slack appears to be disconnected
    <ion-button color="dark" class="btn-small" routerLink="/dashboard/settings/slack" routerDirection="root">
      <ion-icon name="arrow-up-circle" class="padded-icon"></ion-icon>
      Visit Slack settings to reinstall
    </ion-button>
  </div>

  <ion-grid class="constrained-content main-grid">
    <ion-row>
      <ion-col size="12">
        <div class="customer-create-content">
          <div class="flex-space-between flexed-align-center">
            <h1 class="card-header">Select channels to connect</h1>
            <div class="pill-tab-container">
              <ion-select
                *ngIf="connectedTeams?.length > 1"
                [(ngModel)]="selectedTeam"
                (ionChange)="loadChannels(true)"
                interface="popover"
                style="font-size: 0.8rem; margin-right: 10px"
              >
                <ion-select-option *ngFor="let connectedTeam of connectedTeams" [value]="connectedTeam">
                  {{ connectedTeam.name }} workspace
                </ion-select-option>
              </ion-select>

              <span
                class="round-pill-tab round-pill-tab-left"
                [ngClass]="{
                'round-pill-tab-active': isFilteringSharedChannels
              }"
                (click)="isFilteringSharedChannels = true; handleFilter()"
                ngxTippy
                data-tippy-content="Shared channels with external customers and vendors via Slack Connect"
                [tippyProps]="{
                    placement: 'bottom'
                  }"
              >
                <ion-icon [name]="isFilteringSharedChannels ? 'business' : 'business-outline'"></ion-icon>
                Shared
              </span>
              <span
                class="round-pill-tab round-pill-tab-right"
                [ngClass]="{
                'round-pill-tab-active': !isFilteringSharedChannels
              }"
                (click)="isFilteringSharedChannels = false; handleFilter()"
                ngxTippy
                data-tippy-content="Internal channels for support (e.g. #it-support)"
                [tippyProps]="{
                    placement: 'bottom'
                  }"
              >
                <ion-icon [name]="!isFilteringSharedChannels ? 'people' : 'people-outline'"></ion-icon>
                Internal
              </span>
            </div>
          </div>
          <div
            class="flex-space-between"
            [hidden]="!showHelpBanner"
            style="
              background: #eafeea;
              padding: 15px;
              border-radius: 6px;
              color: #006600;
              margin-top: 15px;
              margin-bottom: 0;
              font-size: 0.8rem;
            "
          >
            <span>
              <ion-icon name="checkmark-outline" style="margin-right: 3px"></ion-icon>
              Choose channels and tickets will be tracked in the background automatically
              <a (click)="openHelpdesk()"> Learn more&nbsp;<ion-icon name="open-outline"></ion-icon> </a>
            </span>
            <a (click)="showHelpBanner = false">
              <ion-icon name="close"></ion-icon>
            </a>
          </div>
        </div>

        <ion-card class="outline-card">
          <ng-container *ngIf="!isLoading">
            <div *ngIf="!teamConnectedToSlack" class="customer-create-content">
              <div style="font-size: 16px; margin-bottom: 20px" class="admin-bar">
                New features have been added that require you to re-authenticate to Slack before connecting additional
                channels.
              </div>
              <a (click)="connectTeamToSlack()">
                <img
                  alt="Add to Slack"
                  height="40"
                  width="139"
                  src="https://platform.slack-edge.com/img/add_to_slack.png"
                  srcset="
                    https://platform.slack-edge.com/img/add_to_slack.png    1x,
                    https://platform.slack-edge.com/img/add_to_slack@2x.png 2x
                  "
                />
              </a>
            </div>
            <div *ngIf="teamConnectedToSlack && !userConnectedToSlack">
              <div class="admin-bar flex-space-between" style="border-radius: 8px">
                <ion-button
                  class="fake-button"
                  fill="clear"
                  color="dark"
                  (click)="connectUserToSlack()"
                  [disabled]="true"
                >
                  <ion-icon name="information-circle-outline" class="padded-icon"></ion-icon>
                  Additional permissions are required to see private channels.
                </ion-button>

                <ion-button fill="clear" (click)="connectUserToSlack()">
                  <ion-icon name="logo-slack" class="padded-icon"></ion-icon>
                  Authorize Slack to see your private channels
                </ion-button>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="teamConnectedToSlack">
            <div class="top-searchbar flex-space-between">
              <ion-searchbar
                mode="ios"
                placeholder="Search channels..."
                showCancelButton="never"
                [(ngModel)]="searchText"
                (ionChange)="handleFilter()"
              ></ion-searchbar>
              <div class="flexed">
                <ion-button
                  (click)="selectAll()"
                  color="light"
                  class="btn-small"
                  [hidden]="selectedChannels.length > 0 && filteredChannels.length === selectedChannels.length"
                >
                  Select all
                </ion-button>
                <ion-button
                  (click)="deselectAll()"
                  color="light"
                  class="btn-small"
                  [hidden]="!selectedChannels.length || selectedChannels.length < filteredChannels.length"
                >
                  Deselect all
                </ion-button>
              </div>
            </div>
            <ion-list *ngIf="isLoading">
              <ion-list-header>
                <ion-skeleton-text [animated]="true" style="width: 80px"></ion-skeleton-text>
              </ion-list-header>
              <ion-item>
                <ion-skeleton-text [animated]="true" slot="start" style="width: 30px"></ion-skeleton-text>
                <ion-label>
                  <h3>
                    <ion-skeleton-text [animated]="true" style="width: 80%"></ion-skeleton-text>
                  </h3>
                </ion-label>
              </ion-item>
              <ion-item>
                <ion-skeleton-text [animated]="true" slot="start" style="width: 30px"></ion-skeleton-text>
                <ion-label>
                  <h3>
                    <ion-skeleton-text [animated]="true" style="width: 70%"></ion-skeleton-text>
                  </h3>
                </ion-label>
              </ion-item>
              <ion-item>
                <ion-skeleton-text [animated]="true" slot="start" style="width: 30px"></ion-skeleton-text>
                <ion-label>
                  <h3>
                    <ion-skeleton-text [animated]="true" style="width: 60%"></ion-skeleton-text>
                  </h3>
                </ion-label>
              </ion-item>
              <ion-item>
                <ion-skeleton-text [animated]="true" slot="start" style="width: 30px"></ion-skeleton-text>

                <ion-label>
                  <h3>
                    <ion-skeleton-text [animated]="true" style="width: 75%"></ion-skeleton-text>
                  </h3>
                </ion-label>
              </ion-item>
            </ion-list>
            <ng-container *ngIf="!isLoading">
              <ngx-datatable
                class="material"
                columnMode="force"
                [headerHeight]="50"
                [footerHeight]="50"
                [rowHeight]="50"
                [scrollbarH]="true"
                [rows]="filteredChannels"
                [selected]="selectedChannels"
                selectionType="checkbox"
                [selectAllRowsOnPage]="false"
                [displayCheck]="false"
                [reorderable]="true"
                (select)="onSelect($event)"
              >
                <ngx-datatable-column
                  [width]="30"
                  [sortable]="false"
                  [canAutoResize]="false"
                  [draggable]="false"
                  [resizeable]="false"
                  [headerCheckboxable]="true"
                  [checkboxable]="true"
                >
                </ngx-datatable-column>
                <ngx-datatable-column name="Channel" prop="name">
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    <a class="row-title row-link" (click)="toggleRowSelected(row)">
                      <ion-icon name="lock-closed" *ngIf="row.isPrivate"></ion-icon>
                      <span *ngIf="!row.isPrivate">#</span>
                      {{row.name}}
                    </a>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Type" prop="isShared">
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    <ion-badge color="light" *ngIf="!row.isShared">internal</ion-badge>
                    <ion-badge *ngIf="row.isShared">shared</ion-badge>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Visibility" prop="isPrivate">
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    <span *ngIf="!row.isPrivate">public</span>
                    <span *ngIf="row.isPrivate">private</span>
                  </ng-template>
                </ngx-datatable-column>
              </ngx-datatable>
            </ng-container>
          </ng-container>
          <div *ngIf="!isLoading && (publicChannelsCursor || connectedChannelsCursor || userChannelsCursor)">
            <ion-button size="full" (click)="loadChannels()" class="no-margin">
              Not all channels shown. Click to load more
            </ion-button>
          </div>
        </ion-card>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="!isLoading && !customerChannels?.size">
      <ion-col size="12" style="text-align: center; padding: 10px 0 20px 0">
        <ion-button fill="clear" (click)="goBack()"> Skip for now </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>

<ion-footer *ngIf="teamConnectedToSlack && selectedChannels?.length">
  <ion-toolbar style="text-align: center; padding: 20px; margin-left: auto; margin-right: auto">
    <div class="flexed" style="justify-content: center">
      <ng-container *ngIf="!authService.selectedProject">
        <ion-button fill="clear" [disabled]="true" color="dark" class="fake-button">Add to:</ion-button>
        <ion-button
          fill="clear"
          color="dark"
          (click)="selectProject()"
          class="button-dark-border"
          style="margin-right: 5px"
        >
          <ion-icon
            [name]="project?.name ? 'folder-open' : 'folder-open-outline'"
            class="padded-icon button-icon"
          ></ion-icon>
          {{ project?.name ? project.name : project?.id ?? 'Select a project...' }}
          <ion-icon name="chevron-down-outline" class="icon-padded-left button-icon"></ion-icon>
        </ion-button>
      </ng-container>
      <ion-button (click)="save()" color="success" [disabled]="isLoading || !project?.id">
        Connect selected channels
        <ion-icon name="arrow-forward-outline" class="icon-padded-left"></ion-icon>
      </ion-button>
    </div>
  </ion-toolbar>
</ion-footer>
